import getConfig from "next/config"
import Script from "next/script"

/**
 * Check if Maze is enabled on the environment
 */
export const isMazeEnabled = (): boolean => getConfig().publicRuntimeConfig.MAZE_ENABLED == "true"

export const MazeUserTesting = () => {
  if (!isMazeEnabled()) {
    return null
  }

  const MAZE_API_KEY = getConfig().publicRuntimeConfig.MAZE_API_KEY

  return (
    <>
      <Script
        id="maze-snippet"
        data-testid="maze-snippet"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function (m, a, z, e) {
              var s, t;
              try {
                t = m.sessionStorage.getItem('maze-us');
              } catch (err) {}

              if (!t) {
                t = new Date().getTime();
                try {
                  m.sessionStorage.setItem('maze-us', t);
                } catch (err) {}
              }

              s = a.createElement('script');
              s.src = z + '?apiKey=' + e;
              s.async = true;
              a.getElementsByTagName('head')[0].appendChild(s);
              m.mazeUniversalSnippetApiKey = e;
            })(window, document, 'https://snippet.maze.co/maze-universal-loader.js', '${MAZE_API_KEY}');
            `,
        }}
      />
    </>
  )
}
